import { WATCH_ORDERS } from "../actionTypes";

export const watchordersfunc = (data) => {
  return {
    type: WATCH_ORDERS,
    data: data,
  };
};
